module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lesson"
  }, [_c('div', {
    staticClass: "lesson-time",
    style: ({
      borderColor: _vm.event.color
    })
  }, [_vm._v("\n    " + _vm._s(_vm._f("LT")(_vm.event.start_time)) + "\n    "), _c('br'), _vm._v("\n    " + _vm._s(_vm._f("LT")(_vm.event.end_time)) + "\n  ")]), _vm._v(" "), _c('div', [_vm._v(" " + _vm._s(_vm.event.title)), (_vm.eventHasAnyKlass(_vm.event.klasses)) ? _c('span', [_vm._v(",")]) : _vm._e(), _vm._v("\n    " + _vm._s(_vm._f("klassList")(_vm.event.klasses))), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "meta-info"
  }, [_vm._v(_vm._s(_vm.showType))])]), _vm._v(" "), (_vm.event.substitute_for) ? _c('div', [_c('span', {
    staticClass: "icon-users3"
  }), _vm._v(_vm._s(_vm.$t('vue2.substitute_hours.substitute_for')) + ":\n    " + _vm._s(_vm.event.substitute_for) + "\n  ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "align-right"
  }, [_vm._v(_vm._s(_vm.eventDuration))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e4ba18a2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Hours/Lesson.vue
// module id = 1766
// module chunks = 1